import { Component } from '@angular/core';
import { Events, IonicPage, NavController, NavParams } from 'ionic-angular';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { LockedDayService } from '../../../services/locked-day/locked-day.service';
import { VesselService } from '../../../services/vessel/vessel.service';
import { State } from '@progress/kendo-data-query';
import { columns } from '../../daily-progress-report/daily-progress-report-preview/daily-progress-report-preview.config';
import { DbContext } from '../../../services/data/dbcontext.service';
import { MorningMinutesPermissions } from '../../../models/permissions/permission.models';
import { PtLuxonDate } from '../../../models/projects/date.models';
import { NavHelperService } from '../../../services/nav/nav-helper.service';
import {
  MorningMinutesEditor,
  MorningMinutesReportPreviewData
} from '../../../models/morning-minutes/morning-minutes.models';
import { MorningMinutesReportService } from '../../../services/morning-minutes/morning-minutes-report.service';
import { MorningMinutesService } from '../../../services/morning-minutes/morning-minutes.service';
import { cloneDeep } from 'lodash';
import { DateService } from '../../../services/date/date.service';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-morning-minutes-report-preview',
  templateUrl: 'morning-minutes-report-preview.html',
})
export class MorningMinutesReportPreviewPage {
  config = AppConfig.settings;

  summaryLoading: boolean;
  previewLoading: boolean;
  loadingReport: boolean;
  amending: boolean;
  date: PtLuxonDate;
  displayDate: string;
  currentVersionNumber: string;
  columns = columns;
  state: State;

  morningMinutesEditor: MorningMinutesEditor;
  completeDay: boolean;
  currentVesselId: number;
  currentVesselName: string;
  currentSetupConfigured: boolean;

  pdfPreviewUrl: string;

  permissions: MorningMinutesPermissions = new MorningMinutesPermissions();

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public events: Events,
              private permissionService: PermissionsService,
              private lockedDayService: LockedDayService,
              private vesselService: VesselService,
              private morningMinutesService: MorningMinutesService,
              private morningMinutesReportService: MorningMinutesReportService,
              private navHelperService: NavHelperService,
              private dateService: DateService,
              private dbContext: DbContext,
  ) {
    this.date = this.navParams.get('date');
    this.morningMinutesEditor = this.navParams.get('editor');
    this.completeDay = this.navParams.get('completeDay');
    this.amending = this.navParams.get('amending');
    this.displayDate = this.date.dateTime.toFormat('dd/MM/yyyy');
    this.navHelperService.currentSetupConfigured.subscribe(currentSetupConfigured => {
      this.currentSetupConfigured = currentSetupConfigured;
    });
  }

  async ngOnInit() {
    this.permissions = await this.permissionService.morningMinutesPermissions();

    if (this.morningMinutesEditor == null) {
      this.morningMinutesEditor = await this.morningMinutesService.getAndUpdateMorningMinutesData(this.date);
    }
  }

  ionViewDidLoad() {
    if (this.amending) {
      this.navHelperService.warned = false; // so the user is warned if they go back a page and try and leave while still amending
      this.navHelperService.unsavedChanges = true;
      this.navHelperService.showWarning = false;
    }

    if (this.currentSetupConfigured) {
      this.summaryLoading = true;
      this.previewLoading = true;

      this.vesselService.getEditor().then(async editor => {
        this.currentVesselName = editor.name;
        this.currentVesselId = editor.id;

        await this.loadPreviewViewer();
      });

      this.morningMinutesReportService
        .getCurrentMomReportVersionNumber(this.date)
        .then(versionNumber =>
          versionNumber.subscribe(data => {
            this.currentVersionNumber = data;
          }));

      // this.morningMinutesService
      //   .getReportSummary(this.date)
      //   .then(summary => {
      //     this.progressReportSummary = summary;
      //     this.summaryLoading = false;
      //   });
    }
  }

  async generateReport() {
    this.loadingReport = true;
    const downloadLink = this.morningMinutesReportService.getNewMomDownloadLink(this.date, this.currentVesselId, this.config.isImplementerEnvironment);
    this.navHelperService.changesSaved = true;
    this.morningMinutesEditor.isCompleted = true;

    let editorClone = cloneDeep(this.morningMinutesEditor);
    await this.morningMinutesService.saveEditor(editorClone);
    this.events.publish('report generated');
    this.navCtrl.pop();
    this.loadingReport = false;

    setTimeout(() => {
      location.href = downloadLink;
    });
  }

  async loadPreviewViewer() {
    const morningMinutesPreviewData: MorningMinutesReportPreviewData = {
      appData: null,
      appDeletionData: null,
      morningMinutesEditor: this.morningMinutesEditor
    };

    await this.morningMinutesReportService
      .getPreviewReportDownloadLinkWithPendingChanges(this.date.dateTime, this.currentVesselId, this.config.isImplementerEnvironment, morningMinutesPreviewData)
      .subscribe(data => {
        const file = new Blob([data], {type: 'application/pdf'});
        this.pdfPreviewUrl = URL.createObjectURL(file);
      });
  }

  previewLoaded() {
    this.previewLoading = false;
  }

  async downloadReportPreview() {
    const reportPreviewData: MorningMinutesReportPreviewData = {
      appData: null,
      appDeletionData: null,
      morningMinutesEditor: this.morningMinutesEditor
    };

    await this.morningMinutesReportService
      .getPreviewReportDownloadLinkWithPendingChanges(this.date.dateTime, this.currentVesselId, this.config.isImplementerEnvironment, reportPreviewData).subscribe(data => {
        const file = new Blob([data], {type: 'application/pdf'});
        const fileURL = URL.createObjectURL(file);

        const link = document.createElement('a');
        link.href = fileURL;
        link.download = 'MoM Preview.pdf';
        link.click();
      });
  }

  async downloadCurrentMom() {
    const downloadLink = await this.morningMinutesReportService.getCurrentMomDownloadLink(this.date);

    setTimeout(() => {
      location.href = downloadLink;
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/morning-minutes/morning-minutes-report-preview/morning-minutes-report-preview.ts